// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-panel {
  float: left;
  width: 380px;
}

.report-row {
  width: inherit;
}
.report-row input, .report-row mat-select {
  width: -webkit-fill-available;
}

.content-toolbox {
  line-height: 20px;
}

.content-toolbox span {
  float: left;
}

.content-toolbox button {
  float: right;
}

.content-panel {
  display: block;
  margin-top: 15px;
  width: 100%;
  /* position: relative; */
}

.content-list {
  /* position: absolute; */
  /* top: 30px; */
  /* left: 0px; */
  /* right: 0px; */
}

.report-item {
  font-size: 14px;
  line-height: 24px;
  padding: 7px 0px 5px 0px;
  border-bottom: 1px solid var(--toolboxBorder);
}
.report-item mat-icon {
  font-size: 18px;
  line-height: 24px;
  margin-left: 4px;
}

.report-item-type {
  display: inline-block;
}

.report-head-menu {
  float: right;
  padding-top: 5px;
  padding-right: 5px;
  cursor: pointer;
}

.report-item-edit {
  cursor: pointer;
  margin-right: 10px;
  vertical-align: middle;
}

.report-item-menu {
  cursor: pointer;
  float: right;
  margin-right: 3px;
  vertical-align: middle;
}

.report-item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rigth-panel {
  position: absolute;
  top: 0px;
  bottom: 10px;
  left: 380px;
  right: 20px;
  margin-left: 40px;
}

.valid-error {
  float: left;
  margin-top: 15px;
}

::ng-deep .content-panel .mat-tab-label {
  height: 34px !important;
  min-width: 120px !important;
  width: 140px;
}

.menu-item-select mat-icon {
  font-size: 18px;
  margin-right: unset !important;
}
.menu-item-select span {
  line-height: 20px;
}
.menu-item-select .unselect {
  padding-left: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/reports/report-editor/report-editor.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/reports/report-editor/report-editor.component.scss"],"names":[],"mappings":"AAIA;EACI,WAAA;EACA,YALQ;ACEZ;;ADMA;EACI,cAAA;ACHJ;ADKI;EACI,6BAAA;ACHR;;ADOA;EACI,iBAAA;ACJJ;;ADOA;EACI,WAAA;ACJJ;;ADOA;EACI,YAAA;ACJJ;;ADOA;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;ACJJ;;ADOA;EACI,wBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ACJJ;;ADQA;EACI,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,6CAAA;ACLJ;ADOI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;ACLR;;ADUA;EACI,qBAAA;ACPJ;;ADWA;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ACRJ;;ADWA;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;ACRJ;;ADWA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;ACRJ;;ADWA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;ACRJ;;ADWA;EAEI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WA7FQ;EA8FR,WAAA;EACA,iBAAA;ACTJ;;ADYA;EACI,WAAA;EACA,gBAAA;ACTJ;;ADYA;EACI,uBAAA;EACA,2BAAA;EACA,YAAA;ACTJ;;ADcI;EACI,eAAA;EACA,8BAAA;ACXR;ADcI;EACI,iBAAA;ACZR;ADeI;EACI,kBAAA;ACbR","sourcesContent":["\n$panelLeft: 380px;\n$panelRight: 880px;\n\n.left-panel {\n    float: left;\n    width: $panelLeft;\n}\n\n.report-row {\n    width: inherit;\n\n    input, mat-select {\n        width: -webkit-fill-available;\n    }\n}\n\n.content-toolbox {\n    line-height: 20px; \n}\n\n.content-toolbox span {\n    float: left;\n}\n\n.content-toolbox button {\n    float: right;\n}\n\n.content-panel {\n    display: block; \n    margin-top: 15px;\n    width: 100%;\n    /* position: relative; */\n}\n\n.content-list {\n    /* position: absolute; */\n    /* top: 30px; */\n    /* left: 0px; */\n    /* right: 0px; */\n\n}\n\n.report-item {\n    font-size: 14px;\n    line-height: 24px;\n    padding: 7px 0px 5px 0px;\n    border-bottom: 1px solid var(--toolboxBorder);\n    \n    mat-icon {\n        font-size: 18px;\n        line-height: 24px;\n        margin-left: 4px;\n    }\n\n}\n\n.report-item-type {\n    display: inline-block;\n\n}\n\n.report-head-menu {\n    float:right; \n    padding-top: 5px; \n    padding-right: 5px;\n    cursor: pointer;\n}\n\n.report-item-edit {\n    cursor: pointer;\n    margin-right: 10px;\n    vertical-align: middle;\n}\n\n.report-item-menu {\n    cursor: pointer;\n    float: right;\n    margin-right: 3px;\n    vertical-align: middle;\n}\n\n.report-item-label {\n    overflow: hidden; \n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rigth-panel {\n    // float: right;\n    position: absolute;\n    top: 0px;\n    bottom: 10px;\n    left: $panelLeft;\n    right: 20px;\n    margin-left: 40px;\n}\n\n.valid-error {\n    float: left;\n    margin-top: 15px;\n}\n\n::ng-deep .content-panel .mat-tab-label {\n    height: 34px !important;\n    min-width: 120px !important;\n    width: 140px;\n}\n\n.menu-item-select {\n\n    mat-icon {\n        font-size: 18px;\n        margin-right: unset !important;\n    }\n\n    span {\n        line-height: 20px;\n    }\n\n    .unselect {\n        padding-left: 25px;\n    }\n}",".left-panel {\n  float: left;\n  width: 380px;\n}\n\n.report-row {\n  width: inherit;\n}\n.report-row input, .report-row mat-select {\n  width: -webkit-fill-available;\n}\n\n.content-toolbox {\n  line-height: 20px;\n}\n\n.content-toolbox span {\n  float: left;\n}\n\n.content-toolbox button {\n  float: right;\n}\n\n.content-panel {\n  display: block;\n  margin-top: 15px;\n  width: 100%;\n  /* position: relative; */\n}\n\n.content-list {\n  /* position: absolute; */\n  /* top: 30px; */\n  /* left: 0px; */\n  /* right: 0px; */\n}\n\n.report-item {\n  font-size: 14px;\n  line-height: 24px;\n  padding: 7px 0px 5px 0px;\n  border-bottom: 1px solid var(--toolboxBorder);\n}\n.report-item mat-icon {\n  font-size: 18px;\n  line-height: 24px;\n  margin-left: 4px;\n}\n\n.report-item-type {\n  display: inline-block;\n}\n\n.report-head-menu {\n  float: right;\n  padding-top: 5px;\n  padding-right: 5px;\n  cursor: pointer;\n}\n\n.report-item-edit {\n  cursor: pointer;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.report-item-menu {\n  cursor: pointer;\n  float: right;\n  margin-right: 3px;\n  vertical-align: middle;\n}\n\n.report-item-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rigth-panel {\n  position: absolute;\n  top: 0px;\n  bottom: 10px;\n  left: 380px;\n  right: 20px;\n  margin-left: 40px;\n}\n\n.valid-error {\n  float: left;\n  margin-top: 15px;\n}\n\n::ng-deep .content-panel .mat-tab-label {\n  height: 34px !important;\n  min-width: 120px !important;\n  width: 140px;\n}\n\n.menu-item-select mat-icon {\n  font-size: 18px;\n  margin-right: unset !important;\n}\n.menu-item-select span {\n  line-height: 20px;\n}\n.menu-item-select .unselect {\n  padding-left: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
